export default __webpack_public_path__ + "static/media/moneyfacts.4c0fe129.png";